import React from 'react';

import DemoMeeting from '@/components/DemoMeeting';

const ScheduleMeeting = () => {
  return <DemoMeeting />;
};

export default ScheduleMeeting;
